// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"6b94500a","910":"c449fce0"}[chunkId] + ".chunk.js";
};